let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2bAlQ")).then(() => parcelRequire('6l70f'));